<template>
  <FlotoModule>
    <RouterView :key="$route.fullPath" />
  </FlotoModule>
</template>

<script>
import Constants from '@constants'
import { FormActions } from '@state/modules/form'
import { AssetTypeMethods } from '@state/modules/asset-type'
import { CITypeMethods } from '@state/modules/ci-type'
import { CategoryMethods } from '@state/modules/category'
import { ProductTypeMethods } from '@state/modules/product-type'
export default {
  name: 'AssetManagementModule',
  page() {
    return {
      title: `${this.$tc('asset')} ${this.$tc('management')}`,
    }
  },
  beforeRouteEnter(to, from, next) {
    const allowedForms = [Constants.ASSET, Constants.CMDB, Constants.PRODUCT]
    if (
      to.params.moduleName &&
      allowedForms.indexOf(to.params.moduleName) === -1
    ) {
      return next({ name: '404' })
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (from.name.indexOf('software-category') >= 0) {
      this[`${Constants.ASSET_SOFTWARE}CategoriesFetch`]()
    }
    if (
      from.name.indexOf('assettype') >= 0 ||
      from.name.indexOf('-asset-type') >= 0
    ) {
      this.fetchAssetForm()
      this.fetchAssetType()
    }
    if (
      from.name.indexOf('citype') >= 0 ||
      from.name.indexOf('-asset-type') >= 0
    ) {
      this.fetchAssetForm()
      this.fetchCIType()
    }
    if (from.name.indexOf('product-type') >= 0) {
      this.fetchProductTypes()
    }
    // add any module level clean up logic here
    next()
  },
  methods: {
    ...FormActions,
    ...AssetTypeMethods,
    ...CITypeMethods,
    ...CategoryMethods,
    ...ProductTypeMethods,
  },
}
</script>
